import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReplyForwardArrowIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ReplyForwardArrow",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2.14 28C1.51 28 1 27.49 1 26.86 1 14.81 9.37 10.17 17 9.75v-4.6c0-.45.27-.86.68-1.04s.9-.11 1.23.19l11.43 10.28c.24.22.38.53.38.85s-.14.63-.38.85L18.91 26.57c-.34.3-.82.38-1.23.19a1.14 1.14 0 0 1-.68-1.04v-4.7c-1.7-.14-5.4-.11-8.46 2.19-.5.38-1.22.28-1.6-.23-.38-.5-.28-1.22.23-1.6 4.92-3.69 10.95-2.54 11.19-2.49.54.11.92.58.92 1.12v3.15l8.58-7.72-8.58-7.72v3.15c0 .63-.51 1.14-1.14 1.14-7.18 0-14.86 3.9-14.86 14.86 0 .63-.51 1.14-1.14 1.14Z"
    })
  }));
};
ReplyForwardArrowIcon.displayName = 'ReplyForwardArrowIcon';